export default {
      id: "163,4_cm_=_80_+_80-usage",
      viewBox: "0 0 1000 1000",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#163,4_cm_=_80_+_80",
      toString: function () {
        return this.url;
      }
    }